import { find } from 'lodash';
declare var angular: any;

angular
  .module('TeacherControllers')

  .controller('TeacherHomeCtrl', [
    '$scope',
    'api',
    'exam',
    '$translate',
    function($scope, api, exam, $translate) {
      let _profiles;
      $scope.lessons;

      async function calculateLessonsInit(profiles) {
        let usersId = profiles.map(p => p.user.id);

        $scope.lessons = await api.getLessons(usersId, profiles?.[0]?.level);
      }

      function barExamInit(profiles) {
        var counter = {};

        let options = exam.examData.teacher.meanLevelChart;
        for (var i = options.start; i < options.max; i += options.steps) {
          counter[i] = 0;
        }

        profiles.forEach(profile => {
          if (profile?.estimated_scores?.length) {
            var score = profile.estimated_scores[0].score;
            counter[score - (score % options.steps)]++;
          }
        });

        var array = [];
        for (var i = options.start; i < options.max; i += options.steps) {
          $scope.barExam.labels.push(
            i.toString() + ' - ' + (i + options.steps).toString()
          );
          array.push(counter[i]);
        }

        $scope.barExam.data.push(array);
      }

      function pieExamInit(profiles) {
        var counterUnused = 0;
        var counterUsed = 0;

        profiles.forEach(profile => {
          if (profile.time_spent) {
            counterUsed++;
          } else {
            counterUnused++;
          }
        });

        let tr = $translate.instant([
          'teacher_home.unused_account',
          'teacher_home.used_account'
        ]);
        $scope.pieExam.labels.push(tr['teacher_home.unused_account']);
        $scope.pieExam.labels.push(tr['teacher_home.used_account']);

        $scope.pieExam.series.push(counterUnused);
        $scope.pieExam.series.push(counterUsed);
      }

      $scope.clearSphereChoice = function() {
        $scope.sphereChoice = undefined;
        $scope.update();
      };

      $scope.update = function() {
        $scope.datas = {};
        $scope.barExam = {
          labels: [],
          data: []
        };
        $scope.pieExam = {
          labels: [],
          series: []
        };
        $scope.numbers = {
          users: ''
        };
        $scope.lessons = null;

        let datasToDisplay;
        if ($scope.sphereChoice) {
          datasToDisplay = _profiles.filter(profile => {
            return !!find(
              profile.profile_sphere_associations,
              sa => sa?.sphere?.id === $scope.sphereChoice
            );
          });
          calculateLessonsInit(datasToDisplay);
        } else {
          datasToDisplay = _profiles;
        }
        $scope.numbers.users = datasToDisplay.length;

        barExamInit(datasToDisplay);
        pieExamInit(datasToDisplay);
      };

      async function onInit() {
        let data = await api.getInstitutionProfilesWithSpheres();

        console.log('data', data);
        _profiles = data.profiles;
        $scope.spheres = await api.getMySpheres();
        $scope.update();
      }

      onInit();
    }
  ]);
